import {Stack, Typography} from "@mui/material";
import {isEmpty} from "../../config/commonFunctions";
import {keys} from "../../config/nameSpacesKeys";
import {useState} from "react";

export default function ModelDistributionDisplay(props) {
  // console.log(props);
  const [modelDistributionList, setModelDistributionList] = useState(props.objList);
  const {defaultLanguage, mappings, topLabel} = props;

  function getLabel(key, defaultValue) {
    const returnValue = mappings[key] || defaultValue;
    if (!returnValue) {
      return key;
    }
    return returnValue;
  }

  if (!modelDistributionList || modelDistributionList.length === 0) return null;

  return (
    <div>
      <Typography variant="h4" gutterBottom noWrap sx={{pt: 1}}>{topLabel}</Typography>
      {modelDistributionList.getDistributionsList().map((item, index) => {
        return (
          <Stack key={index} sx={{pt: 1}} spacing={1}>
            {!isEmpty(item.format.getList()) && (
              <div>
                <Typography variant="body2" className={"key"}>{getLabel(keys.format, "format")}</Typography>
                {item.format.getList().map((item, index) => (
                  <div key={index}>{getLabel(item.getValue())}</div>
                ))}
              </div>
            )}
            {!isEmpty(getLabel(item.title.getValue(defaultLanguage))) && (<div style={{paddingTop: "8px"}}>
              <Typography variant="body2" className={"key"}>{getLabel(keys.title, "title")}</Typography>
              <Typography variant="body1">{getLabel(item.title.getValue(defaultLanguage))}</Typography>
            </div>)}
            {!isEmpty(getLabel(item.distributionMethod.getValue(defaultLanguage))) && (
              <div style={{paddingTop: "8px"}}>
                <Typography variant="body2" className={"key"}>{getLabel(keys.distributionMethod, "distributionMethod")}</Typography>
                <Typography variant="body1">{getLabel(item.distributionMethod.getValue(defaultLanguage))}</Typography>
              </div>)}
            {!isEmpty(getLabel(item.accessLevel.getValue(defaultLanguage))) && (<div style={{paddingTop: "8px"}}>
              <Typography variant="body2" className={"key"}>{getLabel(keys.accessLevel, "accessLevel")}</Typography>
              <Typography variant="body1">{getLabel(item.accessLevel.getValue(defaultLanguage))}</Typography>
            </div>)}
            {!isEmpty(getLabel(item.amountOfActiveParameters.getValue(defaultLanguage))) && (
              <div style={{paddingTop: "8px"}}>
                <Typography variant="body2" className={"key"}>{getLabel(keys.amountOfActiveParameters, "amountOfActiveParameters")}</Typography>
                <Typography variant="body1">{item.amountOfActiveParameters.getCurrentValue()}</Typography>
              </div>
            )}
            {!isEmpty(getLabel(item.tokensPerParameter.getValue(defaultLanguage))) && (
              <div style={{paddingTop: "8px"}}>
                <Typography variant="body2" className={"key"}> {getLabel(keys.tokensPerParameter, "tokensPerParameter")}</Typography>
                <Typography variant="body1">{item.tokensPerParameter.getCurrentValue()}</Typography>
              </div>
            )}
            <div style={{paddingTop: "8px"}}>
              <Typography variant="body2" className={"key"}>{getLabel(keys.size, "size")}</Typography>
              {item.size.map((sizeItem, index) => (
                <span key={index}>
                  {" "}
                  <Typography variant="body1">
                    {sizeItem.amount.getCurrentValue()} {getLabel(sizeItem.sizeUnit.getValue())}
                  </Typography>
                </span>
              ))}
            </div>
          </Stack>
        );
      })}
    </div>
  );
}
